'use strict';

module.exports = function pathInfoFromFileItem(fileItem) {
	if (!fileItem) {
		throw new Error('invalid-args');
	}
	const components = fileItem.url.split('/');
	if (components[0] === '_v2') {
		return {fileId: components[1], version: 2};
	}
	return {fileId: fileItem.url.slice(fileItem.owner.length + 1), version: 1};

};
